import { Component } from '@angular/core';

@Component({
  selector: 'app-recipientuserlanding',
  templateUrl: './recipientuserlanding.component.html',
  styleUrl: './recipientuserlanding.component.scss'
})
export class RecipientuserlandingComponent {

}
